import { JanelaModal } from '../../participantes/ui/JanelaModal';

interface ConfirmacaoDeLiderancaProps {
    nome: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

/** O popup "Substituir líder?" de `docs/img_refac/img_3.png` (`RN-RA-014`). */
export function ConfirmacaoDeLideranca({ nome, processando, aoCancelar, aoConfirmar }: ConfirmacaoDeLiderancaProps) {
    return (
        <JanelaModal titulo="Substituir líder?" aoFechar={aoCancelar} bloqueada={processando}>
            <p>{`Definir ${nome} como líder substituirá o(a) líder atualmente definido(a).`}</p>
            <p>O grupo continuará na mesma estação, sem perder seu progresso.</p>
            <div className="botoes-confirmacao">
                <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                    Cancelar
                </button>
                <button type="button" className="botao-confirmar" onClick={aoConfirmar} disabled={processando}>
                    {processando ? 'Processando…' : 'Substituir líder'}
                </button>
            </div>
        </JanelaModal>
    );
}
